<template>
  <v-app id="inspire">
    <v-main>
      <Registro/>
    </v-main>
  </v-app>
</template>



<style>

#inspire{
  background: rgb(223, 221, 221);
}
</style>
<script>
import Registro from "../components/Registro";
export default {
  components: {Registro}
}
</script>